import React from 'react';
import MaskedInput from 'react-text-mask';
import SelectState from '../Forms/SelectState';

export default function Receiver(props) {
    return (

        <div className="card shadow mt-4">
            <div className="card-body">
                <h4 className="card-title text-dark">Dados de endereço</h4>
                <div className="form-row">

                    <div className="form-group col-4">
                        <label htmlFor="postal_code">CEP*</label>
                        <MaskedInput
                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                            className={"form-control"}
                            placeholder="00000-000"
                            value={props.postal_code}
                            guide={false}
                            id="postal_code"
                            required
                            name="postal_code"
                            onBlur={props.onBlur}
                            onChange={props.onChange}
                        />
                        <div className="invalid-feedback">
                            Informe o cep
        </div>

                    </div>
                    <div className="form-group col-8">
                        <label htmlFor="cardholder">Rua*</label>
                        <input
                            type="text"
                            className={"form-control"}
                            id="street"
                            value={props.street}
                            name="street"
                            onChange={props.onChange}
                            placeholder="Endereço"
                            required
                        />
                        <div className="invalid-feedback">
                            Informe o endereço
          </div>

                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-4">
                        <label htmlFor="cardholder">Número*</label>
                        <input
                            type="text"
                            className={"form-control"}
                            id="number_address"
                            value={props.number_address}
                            name="number_address"
                            onChange={props.onChange}
                            placeholder="Nº"
                            required
                        />
                        <div className="invalid-feedback">
                            Informe o número
        </div>
                    </div>

                    <div className="form-group col-8">
                        <label htmlFor="cardholder">Bairro*</label>
                        <input
                            type="text"
                            className={"form-control"}
                            id="neighborhood"
                            value={props.neighborhood}
                            name="neighborhood"
                            onChange={props.onChange}
                            placeholder="Bairro"
                            required
                        />
                        <div className="invalid-feedback">
                            Informe o bairro
        </div>

                    </div>
                </div>
                <div className="form-row">
                    <SelectState
                        state_code={props.state_code}
                        onChange={props.onChange}
                    />

                    <div className="form-group col-6">
                        <label htmlFor="cardholder">Cidade*</label>
                        <input
                            type="text"
                            className={"form-control"}
                            id="city"
                            value={props.city}
                            name="city"
                            onChange={props.onChange}
                            placeholder="Cidade"
                            required
                        />
                        <div className="invalid-feedback">
                            Informe o cidade
        </div>
                    </div>
                </div>

            </div>
        </div>





    )
}




